module.exports = new __parcel__URL__("CineBriqueVF.2d541355.avif").toString();